<template>
  <div id="wechatlogin">
  
<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999">微信登录 </li>
</ul>
</div>
</div>

<div class="col-md-6 col-md-offset-2">
<div class="panel panel-default" style="margin-top:40px">
  <div class="panel-heading">首次微信登录需绑定手机号</div>

    <div class="panel-body">


<form class="form-horizontal" action="" method="post">
  <div class="form-group">
    <label  class="col-sm-2 control-label">手机号</label>
    <div class="col-sm-6">
      <input type="text" class="form-control" name="username"  placeholder="手机号"  v-model="username" >
    </div>
     <div class="col-sm-2">
     <input type="button" value="获取短信验证码" id="btn" class="btn btn-default" v-on:click="obtainCode()">
     </div>
  </div>
  <div class="form-group">
    <label  class="col-sm-2 control-label">验证码</label>
    <div class="col-sm-6">
      <input type="text" class="form-control"  name="sms" v-model="sms" placeholder="验证码">
     
    </div>
  </div>
  
  <div class="form-group">
    <div class="col-sm-offset-2 col-sm-8">
      <button type="button" class="btn btn-primary" style="width:150px;background:#0085c8" v-on:click="login()">确定</button>
    </div>
  </div>
</form>

</div>


<div class="panel-footer text-right">版权所有giazh.com</div>
</div>
</div>
<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                            <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>
                    </div>
                </div>
            </div>

</div>


</div>



  </div>


</template>

<script>

export default {
  name: 'Login',
  data(){
    return {
    title:"登录",
    password: '' ,
    username: '' ,
    sms: '' ,
    islogin:false,
    msg:'',
    wx_token:'',
    code:'',

    }
  },
  methods:{
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
    settime: function(val,countdown) {
                  console.log(countdown);
                  if (countdown == 1) { 
                  countdown = 0;
                  val.removeAttribute("disabled"); 
                  val.value="获取短信验证码";  
                  } else { 
                  val.setAttribute("disabled", true); 
                  val.value="重新发送(" + countdown + ")"; 
                  countdown--; 
                  } 
                 var that = this;
               
                 if(countdown>0){
                  setTimeout(function() { 
                  that.settime(val,countdown)
                  },1000)
                  }
            },
     login: function () {
        if(!this.username){
            alert('手机号不能为空');
            return false;
          }
          if(!this.sms){
            alert('验证码不能为空');
            return false;
          }
        var url="https://www.giazh.com/api/wechat_login";

	this.$http.post(url,{tel:this.username,sms:this.sms,wx_token:this.wx_token},{emulateJSON:true}).then(successResponse => {
						if (successResponse.body.status === "success") {
							console.log(successResponse);
							var authorization=successResponse.headers.map.authorization;
							console.log(authorization);
							localStorage.setItem('authorization',authorization);
							localStorage.setItem('username',successResponse.body.username);
							//登录成功跳转页面
							this.$router.push('/search');
							
						}else{
             alert(successResponse.body.msg);
            }
					}).catch(err => {
						if(err.body.error=='invalid.credentials'){
						alert('登录失败');
						}
					      });


    },
         obtainCode: function (tel) {
          if(!this.username){
            alert('手机号不能为空');
            return false;
          }
        var url="https://www.giazh.com/api/wechat_login_sms";
              this.$http.post(url,{tel:this.username},{emulateJSON:true}).then(successResponse => {
              console.log(successResponse);  
              if (successResponse.body === "success") {
                alert("短信验证码已发送,有效期2分钟");
                this.settime(document.getElementById("btn"),60);  
              }else{
               alert(successResponse.body);
              }         
          }).catch(err => {
                console.log(err);
                });


    },
    loginWechat: function (code) {

        var url="https://www.giazh.com/api/login_wechat";
              this.$http.post(url,{code:code},{emulateJSON:true}).then(successResponse => {
            if (successResponse.body.status === "success") {
              console.log(successResponse);
              var authorization=successResponse.headers.map.authorization;
              console.log(authorization);
              localStorage.setItem('authorization',authorization);
              localStorage.setItem('username',successResponse.body.username);
              //登录成功跳转页面
              this.$router.push('/search');
              
            } else if (successResponse.body.status === "need_tel"){
                this.wx_token = successResponse.body.wx_token;

            }
          }).catch(err => {
                console.log(err);
                });


    }
  },
  components:{
  },
  created(){
  this.code = this.$route.query.code;
  console.log(this.code);
  if(this.code){
     this.loginWechat(this.code);
  } else{
     this.$router.push('/search');
  }
	 // if(localStorage.authorization){
		//   this.$router.push('/vi');
		// }
		 

  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}



.thirdpart-login-icon {
    margin: 0;
    width: 120px;
    height: 26px;
    text-align:right;
}

.icon-weixin {
    background-image: url(https://gw.alicdn.com/tfs/TB1A8GcBAP2gK0jSZPxXXacQpXa-72-72.png);
    background-size: contain;
    background-repeat: no-repeat;
    display: inline-block;
}

</style>


// WEBPACK FOOTER //
// src/components/WechatLogin.vue